let _ = require("ES/lib/lodash");

const OFFER_STATII = [null, "unread message", "waiting client", "waiting you", "offer accepted", "deposit paid", "paid in full", "event completed", "reviewed"]; //order of priority is important; the names are magic (if you change them you'll need to search & replace)


/**
 * For data formatted as a "job"
 *
 * @param job
 * @param returnNumeric
 * @returns {number}
 */
let status = function (job, returnNumeric = false) {

    let n_unread = _.get(job, "my_info.n_unread", 0);
    let status = 0;

    if (n_unread > 0) status = 1; //"unread message";

    if (_.get(job, "my_info.mp_agreement", null)) {
        let signed_b = _.get(job, "my_info.mp_agreement.buyer_signed", false);
        let signed_s = _.get(job, "my_info.mp_agreement.speaker_signed", false);
        let is_accepted = _.get(job, "my_info.mp_agreement.is_accepted", false);

        if (is_accepted) {
            status = _.max([status, 4]); //"offer accepted";
            if (_.get(job, "my_info.mp_agreement.is_deposit_paid", false)) status = _.max([status, 5]);
            if (_.get(job, "my_info.mp_agreement.is_balance_paid", false)) status = _.max([status, 6]);
        } else if (signed_b && !signed_s) {
            status = _.max([status, 3]); //"waiting you"
        } else if (!signed_b && signed_s) {
            status = _.max([status, 2]); //"waiting client"
        }
    }

    return (returnNumeric) ? status : this.OFFER_STATII[status];
};



/**
 * For data formatted as an "event"
 *
 * @param event
 * @param sid
 * @param returnNumeric
 * @returns {number}
 */
let statusForEvent = function (event, sid, returnNumeric = false) {

    let status = 0;

    if (_.get(event, ["MPAgreement", sid], false)) {
        if ((_.get(event, ["MPAgreement", sid, "flags"], 0) & 1) > 0) { //flag "1" means "speaker initiated offer"
            status = 2;
        } else {
            status = 3;
        }
        if (_.get(event, ["MPAgreement", sid, "is_accepted"], false)) {
            status = 4;

            if (_.get(event, ["MPPaymentStatus", sid, "deposit"], false)) status = _.max([5, status]);
            if (_.get(event, ["MPPaymentStatus", sid, "balance"], false)) status = _.max([6, status]);
        }

        if (status >= 5) {
            let tomorrow = new Date();
            tomorrow.setDate(tomorrow.getDate() + 1);

            if (_.get(event, "startdate", 0) >= tomorrow) status = 7; //completed
        }


    }
    return (returnNumeric) ? status : this.OFFER_STATII[status];
};
module.exports = {
    OFFER_STATII,
    status,
    statusForEvent
};

/**
 'IS_ROYALTY'        => array(1, 'is a royalty payment'),
 'MP_LINEITEM'       => array(2, 'is a marketplace line item'),
 'BILL_LATER'        => array(4, 'is a bill later/actual price (i.e. travel expense)'), //used to be called FEE_TO_BE_DECIDED_LATER
 'FREE'              => array(8, 'is billed as a free item'),
 'IS_DEPOSIT'        => array(16, 'billed up front'),
 'IS_COMMISSIONABLE' => array(32, 'Is a commissionable fee'),
 'TRAVEL'            => array(64, 'This is a travel fee'),
 'MATERIALS'         => array(128, 'This is a materials fee'),
 'BALANCE'           => array(256, 'This is the balance due after any deposits'),
 'PAYMENT'           => array(512, 'This is a payment against the total amount'), //? DEPRECATED
 'SPEAKING_FEE'      => array(1024, 'This is the main speaking fee. Use in conjuction with IS_DEPOSIT or BALANCE')
 **/


// WEBPACK FOOTER //
// ./src/utils/getOfferStatusForJob.js